let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cQoIB")).then(() => parcelRequire('ay1Qf'));